import React from "react";
import Autopara from "../Autopara/Autopara";

const images = [
  "https://www.shutterstock.com/image-photo/bpo-business-process-outsourcing-concept-600nw-2219791927.jpg",
  "https://img.freepik.com/free-photo/colleagues-with-headphones-working-call-center-office_23-2149256154.jpg?semt=ais_hybrid&w=740&q=80",
  "https://img.freepik.com/free-photo/woman-working-call-center-talking-with-clients-using-headphones-microphone_23-2149256145.jpg",
];

const paragraphText = `
  <strong>BPO (Business Process Outsourcing)</strong> courses 
  prepare students for <em>voice and non-voice processes</em>, 
  international client handling, and call center operations.<br/><br/>
  Special focus on <span style="color: teal; font-weight: bold;">accent training</span>, 
  <span style="color: teal; font-weight: bold;">technical support</span>, 
  and <span style="color: teal; font-weight: bold;">customer engagement</span>.
`;

function AutoparaBPO() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaBPO;
